/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * CyrenCare API
 * CyrenCare NestJS REST API for healthcare survey platform
 * OpenAPI spec version: 2.0
 */
import {
  useInfiniteQuery,
  useMutation,
  useQuery
} from '@tanstack/react-query'
import type {
  InfiniteData,
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query'
import type {
  AddStepToSurveyDto,
  CreateQuestionTreeDto,
  CreateQuestionTreeResponseDto,
  CreateSymptomDto,
  CreateSymptomResponseDto,
  DuplicateQuestionTreeDto,
  DuplicateQuestionTreeResponseDto,
  FindByTreeKeyResultDto,
  FindQuestionTreesDto,
  QuestionTree,
  QuestionTreeControllerFindByTreeKeyParams,
  QuestionTreeControllerSearchParams,
  QuestionTreeControllerSearchSymptomsParams,
  QuestionTreeResponseDto,
  SearchQuestionTreeResultDto,
  SearchSymptomsResultDto,
  UpdateQuestionTreeDto
} from '.././types'
import { customInstance } from '../../custom-instance';
import type { ErrorType } from '../../custom-instance';


type SecondParameter<T extends (...args: any) => any> = Parameters<T>[1];


/**
 * @summary Search steps by treeKey (case-insensitive partial match)
 */
export const questionTreeControllerSearch = (
    params: QuestionTreeControllerSearchParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<SearchQuestionTreeResultDto[]>(
      {url: `/question-trees/search`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getQuestionTreeControllerSearchQueryKey = (params: QuestionTreeControllerSearchParams,) => {
    return [`/question-trees/search`, ...(params ? [params]: [])] as const;
    }

    
export const getQuestionTreeControllerSearchInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof questionTreeControllerSearch>>>, TError = ErrorType<unknown>>(params: QuestionTreeControllerSearchParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof questionTreeControllerSearch>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getQuestionTreeControllerSearchQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof questionTreeControllerSearch>>> = ({ signal }) => questionTreeControllerSearch(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof questionTreeControllerSearch>>, TError, TData> & { queryKey: QueryKey }
}

export type QuestionTreeControllerSearchInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof questionTreeControllerSearch>>>
export type QuestionTreeControllerSearchInfiniteQueryError = ErrorType<unknown>

/**
 * @summary Search steps by treeKey (case-insensitive partial match)
 */
export const useQuestionTreeControllerSearchInfinite = <TData = InfiniteData<Awaited<ReturnType<typeof questionTreeControllerSearch>>>, TError = ErrorType<unknown>>(
 params: QuestionTreeControllerSearchParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof questionTreeControllerSearch>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getQuestionTreeControllerSearchInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getQuestionTreeControllerSearchQueryOptions = <TData = Awaited<ReturnType<typeof questionTreeControllerSearch>>, TError = ErrorType<unknown>>(params: QuestionTreeControllerSearchParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof questionTreeControllerSearch>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getQuestionTreeControllerSearchQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof questionTreeControllerSearch>>> = ({ signal }) => questionTreeControllerSearch(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof questionTreeControllerSearch>>, TError, TData> & { queryKey: QueryKey }
}

export type QuestionTreeControllerSearchQueryResult = NonNullable<Awaited<ReturnType<typeof questionTreeControllerSearch>>>
export type QuestionTreeControllerSearchQueryError = ErrorType<unknown>

/**
 * @summary Search steps by treeKey (case-insensitive partial match)
 */
export const useQuestionTreeControllerSearch = <TData = Awaited<ReturnType<typeof questionTreeControllerSearch>>, TError = ErrorType<unknown>>(
 params: QuestionTreeControllerSearchParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof questionTreeControllerSearch>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getQuestionTreeControllerSearchQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Find question trees by filters (V1 questionTrees)
 */
export const questionTreeControllerFindByFilters = (
    findQuestionTreesDto: FindQuestionTreesDto,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<QuestionTreeResponseDto[]>(
      {url: `/question-trees/find`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: findQuestionTreesDto
    },
      options);
    }
  


export const getQuestionTreeControllerFindByFiltersMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof questionTreeControllerFindByFilters>>, TError,{data: FindQuestionTreesDto}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof questionTreeControllerFindByFilters>>, TError,{data: FindQuestionTreesDto}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof questionTreeControllerFindByFilters>>, {data: FindQuestionTreesDto}> = (props) => {
          const {data} = props ?? {};

          return  questionTreeControllerFindByFilters(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type QuestionTreeControllerFindByFiltersMutationResult = NonNullable<Awaited<ReturnType<typeof questionTreeControllerFindByFilters>>>
    export type QuestionTreeControllerFindByFiltersMutationBody = FindQuestionTreesDto
    export type QuestionTreeControllerFindByFiltersMutationError = ErrorType<unknown>

    /**
 * @summary Find question trees by filters (V1 questionTrees)
 */
export const useQuestionTreeControllerFindByFilters = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof questionTreeControllerFindByFilters>>, TError,{data: FindQuestionTreesDto}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationResult<
        Awaited<ReturnType<typeof questionTreeControllerFindByFilters>>,
        TError,
        {data: FindQuestionTreesDto},
        TContext
      > => {

      const mutationOptions = getQuestionTreeControllerFindByFiltersMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Returns tree info (id, treeKey, treeType) for sx_select symptom/system trees
 * @summary Find a tree by exact treeKey match
 */
export const questionTreeControllerFindByTreeKey = (
    params: QuestionTreeControllerFindByTreeKeyParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<FindByTreeKeyResultDto>(
      {url: `/question-trees/find-by-tree-key`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getQuestionTreeControllerFindByTreeKeyQueryKey = (params: QuestionTreeControllerFindByTreeKeyParams,) => {
    return [`/question-trees/find-by-tree-key`, ...(params ? [params]: [])] as const;
    }

    
export const getQuestionTreeControllerFindByTreeKeyInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof questionTreeControllerFindByTreeKey>>>, TError = ErrorType<unknown>>(params: QuestionTreeControllerFindByTreeKeyParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof questionTreeControllerFindByTreeKey>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getQuestionTreeControllerFindByTreeKeyQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof questionTreeControllerFindByTreeKey>>> = ({ signal }) => questionTreeControllerFindByTreeKey(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof questionTreeControllerFindByTreeKey>>, TError, TData> & { queryKey: QueryKey }
}

export type QuestionTreeControllerFindByTreeKeyInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof questionTreeControllerFindByTreeKey>>>
export type QuestionTreeControllerFindByTreeKeyInfiniteQueryError = ErrorType<unknown>

/**
 * @summary Find a tree by exact treeKey match
 */
export const useQuestionTreeControllerFindByTreeKeyInfinite = <TData = InfiniteData<Awaited<ReturnType<typeof questionTreeControllerFindByTreeKey>>>, TError = ErrorType<unknown>>(
 params: QuestionTreeControllerFindByTreeKeyParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof questionTreeControllerFindByTreeKey>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getQuestionTreeControllerFindByTreeKeyInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getQuestionTreeControllerFindByTreeKeyQueryOptions = <TData = Awaited<ReturnType<typeof questionTreeControllerFindByTreeKey>>, TError = ErrorType<unknown>>(params: QuestionTreeControllerFindByTreeKeyParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof questionTreeControllerFindByTreeKey>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getQuestionTreeControllerFindByTreeKeyQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof questionTreeControllerFindByTreeKey>>> = ({ signal }) => questionTreeControllerFindByTreeKey(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof questionTreeControllerFindByTreeKey>>, TError, TData> & { queryKey: QueryKey }
}

export type QuestionTreeControllerFindByTreeKeyQueryResult = NonNullable<Awaited<ReturnType<typeof questionTreeControllerFindByTreeKey>>>
export type QuestionTreeControllerFindByTreeKeyQueryError = ErrorType<unknown>

/**
 * @summary Find a tree by exact treeKey match
 */
export const useQuestionTreeControllerFindByTreeKey = <TData = Awaited<ReturnType<typeof questionTreeControllerFindByTreeKey>>, TError = ErrorType<unknown>>(
 params: QuestionTreeControllerFindByTreeKeyParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof questionTreeControllerFindByTreeKey>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getQuestionTreeControllerFindByTreeKeyQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Search symptoms by treeKey (symptom/system tree types only)
 */
export const questionTreeControllerSearchSymptoms = (
    params: QuestionTreeControllerSearchSymptomsParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<SearchSymptomsResultDto[]>(
      {url: `/question-trees/symptoms`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getQuestionTreeControllerSearchSymptomsQueryKey = (params: QuestionTreeControllerSearchSymptomsParams,) => {
    return [`/question-trees/symptoms`, ...(params ? [params]: [])] as const;
    }

    
export const getQuestionTreeControllerSearchSymptomsInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof questionTreeControllerSearchSymptoms>>>, TError = ErrorType<unknown>>(params: QuestionTreeControllerSearchSymptomsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof questionTreeControllerSearchSymptoms>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getQuestionTreeControllerSearchSymptomsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof questionTreeControllerSearchSymptoms>>> = ({ signal }) => questionTreeControllerSearchSymptoms(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof questionTreeControllerSearchSymptoms>>, TError, TData> & { queryKey: QueryKey }
}

export type QuestionTreeControllerSearchSymptomsInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof questionTreeControllerSearchSymptoms>>>
export type QuestionTreeControllerSearchSymptomsInfiniteQueryError = ErrorType<unknown>

/**
 * @summary Search symptoms by treeKey (symptom/system tree types only)
 */
export const useQuestionTreeControllerSearchSymptomsInfinite = <TData = InfiniteData<Awaited<ReturnType<typeof questionTreeControllerSearchSymptoms>>>, TError = ErrorType<unknown>>(
 params: QuestionTreeControllerSearchSymptomsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof questionTreeControllerSearchSymptoms>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getQuestionTreeControllerSearchSymptomsInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getQuestionTreeControllerSearchSymptomsQueryOptions = <TData = Awaited<ReturnType<typeof questionTreeControllerSearchSymptoms>>, TError = ErrorType<unknown>>(params: QuestionTreeControllerSearchSymptomsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof questionTreeControllerSearchSymptoms>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getQuestionTreeControllerSearchSymptomsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof questionTreeControllerSearchSymptoms>>> = ({ signal }) => questionTreeControllerSearchSymptoms(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof questionTreeControllerSearchSymptoms>>, TError, TData> & { queryKey: QueryKey }
}

export type QuestionTreeControllerSearchSymptomsQueryResult = NonNullable<Awaited<ReturnType<typeof questionTreeControllerSearchSymptoms>>>
export type QuestionTreeControllerSearchSymptomsQueryError = ErrorType<unknown>

/**
 * @summary Search symptoms by treeKey (symptom/system tree types only)
 */
export const useQuestionTreeControllerSearchSymptoms = <TData = Awaited<ReturnType<typeof questionTreeControllerSearchSymptoms>>, TError = ErrorType<unknown>>(
 params: QuestionTreeControllerSearchSymptomsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof questionTreeControllerSearchSymptoms>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getQuestionTreeControllerSearchSymptomsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Create a new symptom (symptom/system tree)
 */
export const questionTreeControllerCreateSymptom = (
    createSymptomDto: CreateSymptomDto,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<CreateSymptomResponseDto>(
      {url: `/question-trees/symptoms`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createSymptomDto
    },
      options);
    }
  


export const getQuestionTreeControllerCreateSymptomMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof questionTreeControllerCreateSymptom>>, TError,{data: CreateSymptomDto}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof questionTreeControllerCreateSymptom>>, TError,{data: CreateSymptomDto}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof questionTreeControllerCreateSymptom>>, {data: CreateSymptomDto}> = (props) => {
          const {data} = props ?? {};

          return  questionTreeControllerCreateSymptom(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type QuestionTreeControllerCreateSymptomMutationResult = NonNullable<Awaited<ReturnType<typeof questionTreeControllerCreateSymptom>>>
    export type QuestionTreeControllerCreateSymptomMutationBody = CreateSymptomDto
    export type QuestionTreeControllerCreateSymptomMutationError = ErrorType<unknown>

    /**
 * @summary Create a new symptom (symptom/system tree)
 */
export const useQuestionTreeControllerCreateSymptom = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof questionTreeControllerCreateSymptom>>, TError,{data: CreateSymptomDto}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationResult<
        Awaited<ReturnType<typeof questionTreeControllerCreateSymptom>>,
        TError,
        {data: CreateSymptomDto},
        TContext
      > => {

      const mutationOptions = getQuestionTreeControllerCreateSymptomMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * @summary Add an existing step to a survey
 */
export const questionTreeControllerAddToSurvey = (
    addStepToSurveyDto: AddStepToSurveyDto,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<void>(
      {url: `/question-trees/add-to-survey`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: addStepToSurveyDto
    },
      options);
    }
  


export const getQuestionTreeControllerAddToSurveyMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof questionTreeControllerAddToSurvey>>, TError,{data: AddStepToSurveyDto}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof questionTreeControllerAddToSurvey>>, TError,{data: AddStepToSurveyDto}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof questionTreeControllerAddToSurvey>>, {data: AddStepToSurveyDto}> = (props) => {
          const {data} = props ?? {};

          return  questionTreeControllerAddToSurvey(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type QuestionTreeControllerAddToSurveyMutationResult = NonNullable<Awaited<ReturnType<typeof questionTreeControllerAddToSurvey>>>
    export type QuestionTreeControllerAddToSurveyMutationBody = AddStepToSurveyDto
    export type QuestionTreeControllerAddToSurveyMutationError = ErrorType<unknown>

    /**
 * @summary Add an existing step to a survey
 */
export const useQuestionTreeControllerAddToSurvey = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof questionTreeControllerAddToSurvey>>, TError,{data: AddStepToSurveyDto}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationResult<
        Awaited<ReturnType<typeof questionTreeControllerAddToSurvey>>,
        TError,
        {data: AddStepToSurveyDto},
        TContext
      > => {

      const mutationOptions = getQuestionTreeControllerAddToSurveyMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * @summary Create a new question tree (step)
 */
export const questionTreeControllerCreate = (
    createQuestionTreeDto: CreateQuestionTreeDto,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<CreateQuestionTreeResponseDto>(
      {url: `/question-trees`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createQuestionTreeDto
    },
      options);
    }
  


export const getQuestionTreeControllerCreateMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof questionTreeControllerCreate>>, TError,{data: CreateQuestionTreeDto}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof questionTreeControllerCreate>>, TError,{data: CreateQuestionTreeDto}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof questionTreeControllerCreate>>, {data: CreateQuestionTreeDto}> = (props) => {
          const {data} = props ?? {};

          return  questionTreeControllerCreate(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type QuestionTreeControllerCreateMutationResult = NonNullable<Awaited<ReturnType<typeof questionTreeControllerCreate>>>
    export type QuestionTreeControllerCreateMutationBody = CreateQuestionTreeDto
    export type QuestionTreeControllerCreateMutationError = ErrorType<unknown>

    /**
 * @summary Create a new question tree (step)
 */
export const useQuestionTreeControllerCreate = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof questionTreeControllerCreate>>, TError,{data: CreateQuestionTreeDto}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationResult<
        Awaited<ReturnType<typeof questionTreeControllerCreate>>,
        TError,
        {data: CreateQuestionTreeDto},
        TContext
      > => {

      const mutationOptions = getQuestionTreeControllerCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * @summary Update a question tree (e.g., reorder questions, enable/disable)
 */
export const questionTreeControllerUpdate = (
    id: number,
    updateQuestionTreeDto: UpdateQuestionTreeDto,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<QuestionTree>(
      {url: `/question-trees/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updateQuestionTreeDto
    },
      options);
    }
  


export const getQuestionTreeControllerUpdateMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof questionTreeControllerUpdate>>, TError,{id: number;data: UpdateQuestionTreeDto}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof questionTreeControllerUpdate>>, TError,{id: number;data: UpdateQuestionTreeDto}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof questionTreeControllerUpdate>>, {id: number;data: UpdateQuestionTreeDto}> = (props) => {
          const {id,data} = props ?? {};

          return  questionTreeControllerUpdate(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type QuestionTreeControllerUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof questionTreeControllerUpdate>>>
    export type QuestionTreeControllerUpdateMutationBody = UpdateQuestionTreeDto
    export type QuestionTreeControllerUpdateMutationError = ErrorType<void>

    /**
 * @summary Update a question tree (e.g., reorder questions, enable/disable)
 */
export const useQuestionTreeControllerUpdate = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof questionTreeControllerUpdate>>, TError,{id: number;data: UpdateQuestionTreeDto}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationResult<
        Awaited<ReturnType<typeof questionTreeControllerUpdate>>,
        TError,
        {id: number;data: UpdateQuestionTreeDto},
        TContext
      > => {

      const mutationOptions = getQuestionTreeControllerUpdateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * @summary Duplicate a question tree and add it to a survey
 */
export const questionTreeControllerDuplicate = (
    id: number,
    duplicateQuestionTreeDto: DuplicateQuestionTreeDto,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<DuplicateQuestionTreeResponseDto>(
      {url: `/question-trees/${id}/duplicate`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: duplicateQuestionTreeDto
    },
      options);
    }
  


export const getQuestionTreeControllerDuplicateMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof questionTreeControllerDuplicate>>, TError,{id: number;data: DuplicateQuestionTreeDto}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof questionTreeControllerDuplicate>>, TError,{id: number;data: DuplicateQuestionTreeDto}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof questionTreeControllerDuplicate>>, {id: number;data: DuplicateQuestionTreeDto}> = (props) => {
          const {id,data} = props ?? {};

          return  questionTreeControllerDuplicate(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type QuestionTreeControllerDuplicateMutationResult = NonNullable<Awaited<ReturnType<typeof questionTreeControllerDuplicate>>>
    export type QuestionTreeControllerDuplicateMutationBody = DuplicateQuestionTreeDto
    export type QuestionTreeControllerDuplicateMutationError = ErrorType<void>

    /**
 * @summary Duplicate a question tree and add it to a survey
 */
export const useQuestionTreeControllerDuplicate = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof questionTreeControllerDuplicate>>, TError,{id: number;data: DuplicateQuestionTreeDto}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationResult<
        Awaited<ReturnType<typeof questionTreeControllerDuplicate>>,
        TError,
        {id: number;data: DuplicateQuestionTreeDto},
        TContext
      > => {

      const mutationOptions = getQuestionTreeControllerDuplicateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    